import Http from './http.js';
const login = (data) => {
    return Http('get', '/passport/main.bj', data);
};
export default {
    login,
}